import { UploadIcon } from 'assets/icons';
import BaseInput, { FieldLabel } from 'Components/Form/BaseInput';
import OverlayWindow, { WindowSize } from 'Components/OverlayWindow';
import useCreateModal from 'Components/Popups/useCreateModal';
import { ReactNode, useState } from 'react';
import { RegisterOptions } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { QuestionnaireDocument, UploadForm } from './UploadForm';

export interface UploadInputProps extends IUploadField {
  rules?: RegisterOptions;
}
export const UploadInput = ({
  name,
  type,
  rules,
  label,
  ...rest
}: UploadInputProps) => {
  const { questionnaireId: projectId } = useParams();

  return (
    <BaseInput name={name} label={label} {...rest}>
      {({ setValue, getValues }) => (
        <UploadQuestionnaireDocumentButton
          label={label}
          projectId={+projectId!}
          value={getValues(name)}
          onChange={(files) => setValue(name, { files })}
        />
      )}
    </BaseInput>
  );
};

export function UploadQuestionnaireDocumentButton({
  value,
  projectId,
  onChange,
  label,
}: {
  projectId: number;
  label?: string | ((values?: { [x: string]: any }) => ReactNode);
  value: { url: string; title: string; files: QuestionnaireDocument[] };
  onChange: (files: QuestionnaireDocument[]) => void;
}) {
  const Modal = useCreateModal();
  const [view, setView] = useState<
    'upload-documents' | 'select-previously-uploaded'
  >('upload-documents');

  let files = value?.files || [];
  if (value?.url && !files.find((f) => f.url === value.url)) {
    // add old file to the files array
    files.push({ url: value.url, title: value.title });
  }

  return (
    <>
      <label
        onClick={Modal.open}
        className={`transition-all duration-150 text-center px-10 flex ease-linear cursor-pointer disabled:opacity-50 bg-white text-green bg-opacity-100 py-2 border-green border rounded-lg items-center hover:shadow-lg outline-none focus:outline-none mr-3 h-10 w-max`}
      >
        <span className="mr-4">{<UploadIcon />}</span>
        <span className="text-sm">
          {files.length === 0 && 'Upload Documents'}
          {files.length === 1 && files[0].title}
          {files.length > 1 && `${files.length} Documents`}
        </span>
      </label>
      <Modal.Component>
        <OverlayWindow
          size={
            WindowSize.xl +
            'max-h-[40rem] min-h-[40rem] h-[40rem] overlfow-auto'
          }
          paddingSize={'px-0 py-0'}
          onClose={Modal.close}
          title={<FieldLabel label={label} />}
          subTitle={
            <div className="mt-2 flex gap-4 font-bold text-sm">
              <div
                className={`cursor-pointer whitespace-nowrap ${
                  view === 'upload-documents' ? 'text-green' : 'text-gray-700'
                }`}
                onClick={() => setView('upload-documents')}
              >
                Upload Documents
              </div>
              <div
                className={`cursor-pointer  whitespace-nowrap ${
                  view === 'select-previously-uploaded'
                    ? 'text-green  '
                    : 'text-gray-700'
                }`}
                onClick={() => setView('select-previously-uploaded')}
              >
                Select previously uploaded
              </div>
            </div>
          }
        >
          <UploadForm
            view={view}
            value={files}
            projectId={+projectId!}
            onChange={onChange}
          />
        </OverlayWindow>
      </Modal.Component>
    </>
  );
}
